import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";

const GenericDropDown = ({
  label,
  value,
  onChange,
  options = [],
  required = false,
  error = false,
  helperText = "",
  name,
  sx = {},
  inputProps = {},
  MenuProps = {},
  renderValue,
  size = "small",
  InputLabelProps = {},
  ...props
}) => (
  <FormControl
    fullWidth
    margin="dense"
    size={size}
    required={required}
    error={error}
    // sx={{
    //   backgroundColor: "white",
    //   "& .MuiFormLabel-asterisk": { color: "red" },
    //   ...sx,
    // }}
    sx={{
        backgroundColor: "white", 
        borderRadius: "6px", 
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: error ? "red" : "rgba(0, 0, 0, 0.23)",
            },
            "&:hover fieldset": {
                borderColor: error ? "red" : "rgba(0, 0, 0, 0.6)",
            },
            "&.Mui-focused fieldset": {
                borderColor: error ? "red" : "#06adaf",
            },
        },
        "& .MuiFormLabel-asterisk": {
            color: required ? "red" : "inherit",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#06adaf",
        },
        "& .MuiOutlinedInput-root.Mui-focused fieldset": {
            borderColor: "#06adaf",
        },
        ...props.sx
      }}
  >
    {label && <InputLabel id={`${name || label}-label`}>{label}</InputLabel>}
    <Select
      labelId={`${name || label}-label`}
      name={name}
      value={value}
      onChange={onChange}
      input={<OutlinedInput label={label} />}
      renderValue={renderValue}
      MenuProps={MenuProps}
      {...props}
    >
      {options.map((option) =>
        typeof option === "string" ? (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ) : (
          <MenuItem key={option.value} value={option.value}>
            {option.label || option.value}
          </MenuItem>
        )
      )}
    </Select>
    {helperText && <FormHelperText>{helperText}</FormHelperText>}
  </FormControl>
);

export default GenericDropDown;
